import { lazyLoad } from "utils/loadable"

export const HubDashboardWorkspace = lazyLoad(
  () => import("./index"),
  module => module.HubDashboardWorkspace,
)
